var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-timeline-item',{attrs:{"right":"","icon":"message","fill-dot":""}},[_c('v-card',{staticClass:"elevation-2"},[_c('v-card-text',[_vm._v(" "+_vm._s(_vm.data.text)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }